import React from "react";
import { connect } from "react-redux";

import { doDetailLiveTracking, doDetailLiveTrackingNoFetching } from "./stores/thunk";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.liveTracking.isFetching,
      liveTrackingData: state.liveTracking.data,
    };
  }

  return connect(mapStateToProps, {
    doDetailLiveTracking,
    doDetailLiveTrackingNoFetching,
  })(Container);
};
